'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = OnlinepbxModalFields;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function OnlinepbxModalFields(_ref) {
  var tabIndex = _ref.tabIndex,
      onBlur = _ref.onBlur,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      children = _ref.children,
      style = _ref.style,
      className = _ref.className;

  return _react2['default'].createElement(
    'div',
    {
      tabIndex: tabIndex,
      onBlur: onBlur,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      style: style,
      className: (0, _classnames2['default'])('onlinepbx__lib__modal__fields', className) },
    children
  );
}